export const pl = {
    'nav.today': "Przegląd Dnia",
    'nav.calendar': "Kalendarz Popytu",
    'nav.rates': "Ceny i Zasady",
    'nav.automation': "Automatyzacja",
    'nav.audit': "Dziennik Audytu",
    'nav.settings': "Ustawienia",
    'sidebar.status': "Połączono",
    'stat.occupancy': "Obłożenie",
    'stat.adr': "Śr. Cena (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Szac. Przychód",
    'stat.trend.vsLastWeek': "vs Poprz. Tydz.",
    'stat.trend.onPace': "Zgodnie z planem",
    'dashboard.actions.title': "Zalecane Działania",
    'dashboard.actions.empty': "Brak działań.",
    'filter.all': "Wszystkie",
    'filter.pricing': "Ceny",
    'filter.restriction': "Restrykcje",
    'action.approve': "Zatwierdź",
    'action.reject': "Odrzuć",
    'action.risk.low': "niskie ryzyko",
    'action.risk.medium': "średnie ryzyko",
    'action.risk.high': "wysokie ryzyko",
    'action.label.current': "Obecne",
    'action.label.proposed': "Proponowane",
    'action.metric.impact': "Wpływ",
    'action.metric.why': "Dlaczego",
    'action.status.executed': "Auto-Wykonano",
    'header.search': "Szukaj...",
    'header.logout': "Wyloguj",
    'auto.level.title': "Poziom Autopilota",
    'auto.level.manual': "Ręczny",
    'auto.level.manual.desc': "Zatwierdzasz każdą rekomendację.",
    'auto.level.assisted': "Wspomagany",
    'auto.level.assisted.desc': "Auto-zatwierdź niskie ryzyko. Przeglądaj duże zmiany.",
    'auto.level.auto': "W pełni Auto",
    'auto.level.auto.desc': "AI zarządza cenami 24/7 w ramach twoich granic.",
    'auto.level.active': "Aktywny",
    'auto.guardrails.title': "Granice Bezpieczeństwa",
    'auto.guardrails.maxIncrease': "Maks. Dzienny Wzrost",
    'auto.guardrails.maxIncrease.desc': "Unikaj szoków cenowych.",
    'auto.guardrails.maxDecrease': "Maks. Dzienny Spadek",
    'auto.guardrails.maxDecrease.desc': "Unikaj zbyt niskich cen.",
    'auto.guardrails.minRate': "Cena Minimalna",
    'auto.guardrails.minRate.desc': "Nigdy nie sprzedawaj poniżej tej ceny (Netto).",
    'auto.emergency.title': "Kontrola Awaryjna",
    'auto.emergency.label': "Zatrzymanie Awaryjne",
    'auto.emergency.desc': "Natychmiast wstrzymaj automatyzację.",
    'auto.emergency.btn': "WSTRZYMAJ SYSTEM",
    'rates.filter.all': "Wszystkie Typy Pokoi",
    'rates.filter.next14': "Następne 14 Dni",
    'rates.export': "Eksportuj",
    'audit.table.time': "Czas",
    'audit.table.actor': "Użytkownik",
    'audit.table.category': "Kategoria",
    'audit.table.action': "Działanie",
    'audit.table.details': "Szczegóły",
    'audit.table.status': "Status",
    'settings.pms.title': "Połączenie PMS",
    'settings.pms.connected': "Połączono z",
    'settings.pms.disconnect': "Rozłącz",
    'settings.account.title': "Konto",
    'settings.account.role': "Rola",
    'settings.restart': "Restart Onboardingu",
    'onboard.title': "Połącz PMS",
    'onboard.desc': "Wybierz swój system PMS do synchronizacji.",
    'onboard.connecting': "Łączenie...",
    'onboard.connect': "Połącz",
    'onboard.success.title': "Konfiguracja Zakończona!",
    'onboard.success.desc': "**SynthHotel Berlin** jest teraz zsynchronizowany.",
    'onboard.success.sub': "Zaimportowano 3 typy pokoi, 14 planów cenowych i 243 rezerwacje.",
    'onboard.btn.dashboard': "Idź do Pulpitu",
    'action.dynamic.weekend.title': "Podnieś Cenę na Weekend",
    'action.dynamic.weekend.desc': "Obłożenie > 75% Sobota, duży popyt (+12 pokoi w 24h).",
    'action.dynamic.minstay.title': "Włącz Min. Pobyt 2 Noce",
    'action.dynamic.minstay.desc': "Koncert Taylor Swift. Zablokuj pobyty na 1 noc.",
    'action.dynamic.distress.title': "Obniż Cenę (Słaby Popyt)",
    'action.dynamic.distress.desc': "Obłożenie 35% w przyszły Wtorek. Konkurencja obniżyła o 10€.",
    'action.dynamic.gap.title': "Wypełnij Lukę: Usuń CTA",
    'action.dynamic.gap.desc': "Luka jednej nocy. Usuń 'Zamknięte na Przyjazd', aby sprzedać.",
};
